if (!customElements.get('slider-gallery')) {
  class SliderGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this));
      }
    }

    initSlider() {
      // Ensure jQuery and Slick are fully loaded before executing
      if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
        setTimeout(this.initSlider.bind(this), 50);
        return;
      }
      
      const $ = window.jQuery;
      const sliderEl = this.querySelector('.slider-gallery');
      if (!sliderEl || sliderEl.classList.contains('slick-initialized')) return;

      const autoplay = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || 5) * 1000;
      const speed = parseInt(this.dataset.transition || 600);
      const loop = this.dataset.loop === 'true';
      const showArrowsMobile = this.dataset.showArrowsMobile === 'true';

      // Use strict clean SVGs to match design and avoid theme default box borders
      const chevronLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      const chevronRight = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

      const prevArrowHtml = '<button type="button" class="slick-prev" aria-label="' + (window.theme && window.theme.strings ? window.theme.strings.previous : 'Previous') + '">' + chevronLeft + '</button>';
      const nextArrowHtml = '<button type="button" class="slick-next" aria-label="' + (window.theme && window.theme.strings ? window.theme.strings.next : 'Next') + '">' + chevronRight + '</button>';

      $(sliderEl).on('init', function () {
        $('.slick-current .lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
      }).slick({
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        speed: speed,
        infinite: loop,
        slidesToShow: 2,
        centerMode: true,
        centerPadding: '5%',
        arrows: true,
        prevArrow: prevArrowHtml,
        nextArrow: nextArrowHtml,
        pauseOnHover: false,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              arrows: showArrowsMobile
            }
          }
        ]
      }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        // Lazy load the next slide image if not already loaded
        const $unloadedImage = $(slick.$slides.get(nextSlide)).find('.lazyload--manual');
        if ($unloadedImage.length) {
          $unloadedImage.removeClass('lazyload--manual').addClass('lazyload');
        }
      });
    }

    onBlockSelect(event) {
      const sliderEl = this.querySelector('.slider-gallery');
      const index = $(event.target).closest('.slick-slide').data('slick-index');
      if (index !== undefined) {
        $(sliderEl).slick('slickGoTo', index).slick('slickPause');
      }
    }

    onBlockDeselect(event) {
      const sliderEl = this.querySelector('.slider-gallery');
      $(sliderEl).slick('slickPlay');
    }
  }

  customElements.define('slider-gallery', SliderGallery);
}
